export const environment = {
  apiUrl: 'https://szdmap.sit-co.ru/api',
  s3Path: 'https://s3.ru1.storage.beget.cloud/7073a12603cc-szdmap',
};
